/**
 * 钉钉流程台账：按业务类型匹配审批模板，并从 formMap 抽取台账列
 */

export const LEDGER_TYPES = [
  {
    key: 'expense',
    name: '报销',
    icon: 'logo-yen',
    keywords: ['报销'],
    excludeKeywords: [],
    columns: [
      {key: 'amount', title: '报销金额', aliases: ['报销金额', '金额', '合计金额', '报销总额', '费用合计'], width: 120},
      {key: 'type', title: '费用类型', aliases: ['报销类型', '费用类型', '费用科目', '类别'], minWidth: 110},
      {key: 'reason', title: '事由', aliases: ['报销事由', '事由', '申请事由', '说明'], minWidth: 160},
      {key: 'dept', title: '费用归属', aliases: ['费用归属', '所属部门', '部门', '费用承担部门'], minWidth: 120},
      {key: 'payee', title: '收款人', aliases: ['收款人', '收款方', '申请人'], minWidth: 100},
    ],
  },
  {
    key: 'payment',
    name: '支付',
    icon: 'md-card',
    keywords: ['支付', '付款'],
    excludeKeywords: ['报销'],
    columns: [
      {key: 'amount', title: '支付金额', aliases: ['支付金额', '付款金额', '金额', '合计金额'], width: 120},
      {key: 'payee', title: '收款方', aliases: ['收款单位', '收款人', '收款方', '供应商'], minWidth: 140},
      {key: 'reason', title: '支付事由', aliases: ['支付事由', '付款事由', '事由', '说明'], minWidth: 160},
      {key: 'method', title: '付款方式', aliases: ['付款方式', '支付方式', '结算方式'], width: 110},
      {key: 'contract', title: '合同/项目', aliases: ['合同名称', '合同', '项目名称', '关联合同'], minWidth: 140},
    ],
  },
  {
    key: 'leave',
    name: '请假',
    icon: 'ios-calendar',
    keywords: ['请假'],
    excludeKeywords: [],
    columns: [
      {key: 'leaveType', title: '请假类型', aliases: ['请假类型', '假别', '类型'], width: 110},
      {key: 'start', title: '开始时间', aliases: ['开始时间', '请假开始', '起始时间'], width: 160},
      {key: 'end', title: '结束时间', aliases: ['结束时间', '请假结束', '截止时间'], width: 160},
      {key: 'duration', title: '时长', aliases: ['请假时长', '时长', '天数', '请假天数'], width: 90},
      {key: 'reason', title: '事由', aliases: ['请假事由', '事由', '说明'], minWidth: 160},
    ],
  },
  {
    key: 'supply',
    name: '物品领用',
    icon: 'md-cube',
    keywords: ['物品领用', '物资领用', '领用'],
    excludeKeywords: [],
    columns: [
      {key: 'item', title: '物品名称', aliases: ['物品名称', '物资名称', '名称', '领用物品'], minWidth: 140},
      {key: 'qty', title: '数量', aliases: ['数量', '领用数量'], width: 80},
      {key: 'reason', title: '领用事由', aliases: ['领用事由', '事由', '用途', '说明'], minWidth: 140},
      {key: 'date', title: '领用日期', aliases: ['领用日期', '领用时间', '日期'], width: 140},
      {key: 'returnDate', title: '归还日期', aliases: ['归还日期', '预计归还'], width: 140},
    ],
  },
  {
    key: 'seal',
    name: '用印申请',
    icon: 'md-ribbon',
    keywords: ['用印', '用章', '盖章'],
    excludeKeywords: [],
    columns: [
      {key: 'doc', title: '用印文件', aliases: ['用印文件', '文件名称', '文件名', '合同名称'], minWidth: 160},
      {key: 'sealType', title: '印章类型', aliases: ['印章类型', '用章类型', '印章', '章类型'], width: 120},
      {key: 'copies', title: '份数', aliases: ['用印份数', '份数', '盖章份数'], width: 80},
      {key: 'reason', title: '用印事由', aliases: ['用印事由', '事由', '说明'], minWidth: 140},
      {key: 'docType', title: '文件类型', aliases: ['文件类型', '用印类型', '类型'], width: 110},
    ],
  },
  {
    key: 'resign',
    name: '离职申请',
    icon: 'md-exit',
    keywords: ['离职'],
    excludeKeywords: [],
    columns: [
      {key: 'leaveDate', title: '离职日期', aliases: ['离职日期', '最后工作日', '预计离职日期', '离职时间'], width: 140},
      {key: 'reason', title: '离职原因', aliases: ['离职原因', '原因', '事由'], minWidth: 160},
      {key: 'handover', title: '交接人', aliases: ['交接人', '工作交接人', '接手人'], minWidth: 110},
      {key: 'dept', title: '所在部门', aliases: ['所在部门', '部门', '离职部门'], minWidth: 120},
      {key: 'position', title: '职位', aliases: ['职位', '岗位', '职务'], width: 110},
    ],
  },
  {
    key: 'car',
    name: '用车申请',
    icon: 'md-car',
    keywords: ['用车', '车辆'],
    excludeKeywords: [],
    columns: [
      {key: 'start', title: '用车时间', aliases: ['用车时间', '开始时间', '出发时间'], width: 160},
      {key: 'end', title: '返回时间', aliases: ['返回时间', '结束时间', '预计返回'], width: 160},
      {key: 'dest', title: '目的地', aliases: ['目的地', '前往地点', '地点'], minWidth: 120},
      {key: 'reason', title: '用车事由', aliases: ['用车事由', '事由', '用途'], minWidth: 140},
      {key: 'vehicle', title: '车辆', aliases: ['车辆', '车牌', '车牌号', '用车车辆'], width: 120},
    ],
  },
  {
    key: 'regular',
    name: '转正申请',
    icon: 'md-checkmark-circle',
    keywords: ['转正'],
    excludeKeywords: [],
    columns: [
      {key: 'joinDate', title: '入职日期', aliases: ['入职日期', '入职时间'], width: 140},
      {key: 'probation', title: '试用期', aliases: ['试用期', '试用期限'], width: 110},
      {key: 'regularDate', title: '转正日期', aliases: ['转正日期', '预计转正日期', '转正时间'], width: 140},
      {key: 'position', title: '岗位', aliases: ['岗位', '职位', '转正岗位'], minWidth: 110},
      {key: 'summary', title: '转正述职', aliases: ['转正评价', '自我评价', '工作总结', '转正述职', '述职'], minWidth: 160},
    ],
  },
];

export function getLedgerType(key) {
  return LEDGER_TYPES.find((t) => t.key === key) || null;
}

/** 按名称关键词匹配审批模板 */
export function matchProcesses(processes, typeDef) {
  const list = Array.isArray(processes) ? processes : [];
  if (!typeDef) return [];
  const kws = typeDef.keywords || [];
  const excludes = typeDef.excludeKeywords || [];
  return list.filter((p) => {
    const name = String(p.name || '');
    if (!kws.some((k) => name.includes(k))) return false;
    if (excludes.some((k) => name.includes(k))) return false;
    return true;
  });
}

function normalizeFormMap(detail) {
  if (!detail) return {};
  if (detail.formMap && typeof detail.formMap === 'object') return detail.formMap;
  const vals = detail.formComponentValues || detail.form_component_values || [];
  const map = {};
  (Array.isArray(vals) ? vals : []).forEach((f) => {
    if (f && f.name != null) map[f.name] = f.value;
  });
  return map;
}

function stringifyCell(v) {
  if (v == null || v === '') return '';
  if (typeof v === 'object') {
    try { return JSON.stringify(v); } catch (e) { return String(v); }
  }
  return String(v);
}

/** 按别名从 formMap 取值（精确优先，再包含匹配） */
export function pickFormValue(formMap, aliases) {
  const map = formMap || {};
  const keys = Object.keys(map);
  for (let i = 0; i < aliases.length; i++) {
    const a = aliases[i];
    if (Object.prototype.hasOwnProperty.call(map, a) && map[a] != null && map[a] !== '') {
      return stringifyCell(map[a]);
    }
  }
  for (let i = 0; i < aliases.length; i++) {
    const a = aliases[i];
    const hit = keys.find((k) => k.includes(a) || a.includes(k));
    if (hit && map[hit] != null && map[hit] !== '') {
      return stringifyCell(map[hit]);
    }
  }
  return '';
}

/** 将实例详情转为台账行 */
export function buildLedgerRow(detail, typeDef, processMeta) {
  const formMap = normalizeFormMap(detail);
  const id = detail.processInstanceId || detail.process_instance_id || '';
  const row = {
    _id: id,
    processInstanceId: id,
    title: detail.title || '',
    status: detail.status || '',
    result: detail.result || '',
    originatorUserId: detail.originatorUserId || detail.originator_userid || '',
    createTime: detail.createTime || detail.create_time || '',
    finishTime: detail.finishTime || detail.finish_time || '',
    processCode: (processMeta && processMeta.processCode) || detail.processCode || '',
    processName: (processMeta && processMeta.name) || detail.processName || '',
    formMap,
    raw: detail,
  };
  (typeDef.columns || []).forEach((col) => {
    row[col.key] = pickFormValue(formMap, col.aliases || [col.title]);
  });
  // 请假区间控件常见：一个字段里是 JSON 数组
  if (typeDef.key === 'leave') {
    const range = pickFormValue(formMap, ['请假时间', '时间', '起止时间']);
    if (range && (!row.start || !row.end)) {
      try {
        const arr = JSON.parse(range);
        if (Array.isArray(arr) && arr.length >= 2) {
          if (!row.start) row.start = String(arr[0] || '');
          if (!row.end) row.end = String(arr[1] || '');
        }
      } catch (e) { /* ignore */ }
    }
  }
  return row;
}

export function buildLedgerRows(details, typeDef, processMeta) {
  return (Array.isArray(details) ? details : []).map((d) => buildLedgerRow(d, typeDef, processMeta));
}
